import RepayRequest from './RepayRequest';
import OrderSummary from '../../../../orderSummary/OrderSummary';
import { OngoingPaymentPlan } from '../../../Dashboard.types';
import styles from '../OngoingLoanView.module.css';

const OverdueView = ({
    paymentPlan: { account, interestRate }
}: {
    paymentPlan: OngoingPaymentPlan;
}) => {
    return (
        <div className={styles.OngoingView}>
            <div className={styles.orderSection}>
                <div className={styles.repaymentWrapper}>
                    <RepayRequest account={account} />
                </div>

                <OrderSummary
                    interestRate={interestRate}
                    account={account}
                    title={null}
                />
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default OverdueView;
